export class LoadOpeningHoursForDay {
	static readonly type = "[Resource] Load opening hours for specific day";
	constructor(public day: moment.Moment) {}
}

export class FetchResources {
	static readonly type = "[Resource] Fetch Resources";
}

export class FetchResourcesSuccess {
	static readonly type = "[Resource] Fetch Resources Success";
	constructor(public resources: import("@3volutionsag/ngx-rooms-lib").Resource[]) {}
}

export class FetchResourcesFailure {
	static readonly type = "[Resource] Fetch Resources Failure";
	constructor(public error: any) {}
}
